<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'produtos') {
            next({ name: 'pro-produto-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'produtos') {
            this.$router.push({ name: 'pro-produto-list' });
        }
    },
};
</script>
